import {
  RecruiterSidebarItemState,
  SidebarItemStateHandlerParams,
} from '@features/oneOnboardingAdmin/pages/NewCandidateProfilePage/CustomCandidateProfileSidebar/handlerClasses/types';

export const useRecruiterApprovalGroup = (params: SidebarItemStateHandlerParams): RecruiterSidebarItemState => {
  const { flowWrapper, onboarding } = params;
  const { step: currentStep } = flowWrapper.getCurrentStepAndPage();
  const active = [
    'DOCUMENT_UPLOAD',
    'WORKPRO_INDUCTION_VERIFICATION',
    'DOCUMENT_VALIDATION',
    'RECRUITER_DOCUMENT_UPLOAD',
    'APPROVE',
  ].includes(currentStep);
  const completed = currentStep === 'APPROVE' && onboarding?.status === 'approved';
  const disabled = !(active || completed);

  return {
    active,
    disabled,
    completed,
    onClick: () => {
      return;
    },
  };
};
